/*
  Keeps REPLACE365 in step with the product it covers.
  The Snap selector adds the plan as its own cart line and tags both lines with hidden properties (leading underscore, so
  customers never see them): the wallet line carries _wallets (how many wallets that line holds) and the plan line carries
  _linked. After any cart change this counts the wallets still in the cart and trims the plan lines to match, down to
  zero, so removing the pack removes its protection. Older lines with no tags are recognised by product handle instead.
*/
(function () {
  if (window.__r365sync) return;
  window.__r365sync = true;

  /* Wallets held by each product that REPLACE365 can cover. Used when a line has no _wallets tag, which is every line
     added before the tags existed. */
  var WALLETS = {
    'urban-snap-magnetic-wallet': 1,
    'urban-snap-v2-dual-pack': 2,
    'urban-snap-v2-ultimate-pack': 3,
    'snap-carry-set': 1,
    'nomadic-carry-system-urban-snap': 1,
    'nomadic-carry-system-full-loadout': 1
  };
  var PLAN_HANDLE = 'replace365-accidental-protection';

  var realFetch = window.fetch;
  var busy = false;

  window.fetch = function (input) {
    var p = realFetch.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        return res.clone().json().then(sync);
      }).catch(function () {});
    }
    return p;
  };

  function sync(cart) {
    if (busy || !cart || !cart.items) return;
    var wallets = 0, plans = [];
    cart.items.forEach(function (item) {
      var pr = item.properties || {};
      if (pr._linked === 'r365' || item.handle === PLAN_HANDLE) plans.push(item);
      else if (pr._wallets) wallets += (parseInt(pr._wallets, 10) || 0) * item.quantity;
      else if (WALLETS[item.handle]) wallets += WALLETS[item.handle] * item.quantity;
    });
    if (!plans.length) return;

    var left = wallets, updates = {}, changed = false;
    plans.forEach(function (plan) {
      var keep = Math.max(0, Math.min(plan.quantity, left));
      left -= keep;
      if (keep !== plan.quantity) { updates[plan.key] = keep; changed = true; }
    });
    if (!changed) return;

    busy = true;
    realFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        busy = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      })
      .catch(function () { busy = false; });
  }
})();
